import React, { useEffect, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setTheme, toggleSidebar } from "../../redux/actions/styles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BookIcon from "@mui/icons-material/Book";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuOpenSharpIcon from "@mui/icons-material/MenuOpenSharp";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import InterestsIcon from "@mui/icons-material/Interests";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";

const SidebarOpen = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { outlet, table, section } = useParams();

  const initialRenderSidebar = useRef(true);
  const { sidebarActive } = useSelector((state) => state.styles);

  const { activeOutlet } = useSelector((state) => state.config);

  const { darkTheme } = useSelector((state) => state.styles);

  const { cart } = useSelector((state) => state.checkout);

  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.removeItem("theme");
    }
  }, [darkTheme]);

  const hasWindow = typeof window !== "undefined";

  useEffect(() => {
    if (initialRenderSidebar.current) {
      initialRenderSidebar.current = false;
    } else {
      const windowWidth = hasWindow ? window.innerWidth : null;
      windowWidth < 600 && dispatch(toggleSidebar(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <div className={`sidebar-open ${sidebarActive ? "sidebar-active" : ""}`}>
      <div className="bg-dark" onClick={() => dispatch(toggleSidebar(false))} />

      <div className="wrapper">
        <div className="sidebar-toggle" onClick={() => dispatch(toggleSidebar(sidebarActive ? false : true))}>
          <MenuOpenSharpIcon fontSize="small" />
          <p>Collapse</p>
        </div>

        <div className="menu">
          <div className="section">
            {activeOutlet ? (
              <Link
                to={table ? `/${outlet}/${table}` : `/${outlet}`}
                className={`tab ${
                  pathname === `/${outlet}` ||
                  pathname === `/${outlet}/${table}` ||
                  pathname === `/${outlet}/section/${section}` ||
                  pathname === `/${outlet}/${table}/section/${section}`
                    ? "tab-active"
                    : ""
                }`}
              >
                <div className="icon">
                  <DashboardIcon />
                </div>
                <p>Menu</p>
              </Link>
            ) : (
              <Link to="/" className={`tab ${pathname === "/outlets" ? "tab-active" : ""}`}>
                <div className="icon">
                  <DashboardIcon />
                </div>
                <p>Menu</p>
              </Link>
            )}
            {/* <Link to="/reservations" className={`tab ${pathname === "/reservations" ? "tab-active" : ""}`}>
              <div className="icon">
                <BookIcon />
              </div>
              <p>Reservations</p>
            </Link> */}
            <Link
              to={activeOutlet ? (table ? `/cart/${outlet}/${table}` : `/cart/${outlet}`) : "/cart"}
              className={`tab ${pathname.includes("/cart") ? "tab-active" : ""}`}
            >
              <div className="icon">
                <ShoppingCartIcon />
                {cart.length > 0 && <div className="badge">{cart.length}</div>}
              </div>
              <p>Cart</p>
            </Link>
            {table && (
              <Link
                to={
                  activeOutlet ? (table ? `/your-orders/${outlet}/${table}` : `/your-orders/${outlet}`) : "/your-orders"
                }
                className={`tab ${pathname.includes("/your-orders") ? "tab-active" : ""}`}
              >
                <div className="icon">
                  <RestaurantRoundedIcon />
                </div>
                <p>Orders</p>
              </Link>
            )}

            <div onClick={() => dispatch(setTheme(!darkTheme))} className={`tab`}>
              <div className="icon">{darkTheme ? <LightModeIcon /> : <NightsStayIcon />}</div>
              <p>{darkTheme ? "Light" : "Dark"}</p>
            </div>
          </div>
        </div>
        <div className="settings-tab">
          {isAuthenticated ? (
            <Link
              to={
                activeOutlet
                  ? table
                    ? `/manage/${outlet}/${table}`
                    : outlet
                    ? `/manage/${outlet}`
                    : `/manage`
                  : "/manage"
              }
              className={`tab ${pathname === "/manage" || pathname === `/manage/${outlet}` ? "tab-active" : ""}`}
            >
              <div className="icon">
                <AppRegistrationIcon style={{ fontSize: "1.75rem" }} />
              </div>
              <p>Manage</p>
            </Link>
          ) : (
            <Link
              to={activeOutlet ? (table ? `/more/${outlet}/${table}` : `/more/${outlet}`) : "/more"}
              className={`tab ${pathname.includes("/more") ? "tab-active" : ""}`}
            >
              <div className="icon">
                <InterestsIcon />
              </div>
              <p>More</p>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default SidebarOpen;
